// Fachada do domínio Dashboard — métodos da instância (ver core.ts).
import { dashboardService } from './core';

// ─── Operações com dados (via adapter) ──────────────────────────
export const getFunnelData            = dashboardService.getFunnelData;
export const getTeamPerformance       = dashboardService.getTeamPerformance;
export const getActivitiesStats       = dashboardService.getActivitiesStats;
export const getLeadAcquisitionData   = dashboardService.getLeadAcquisitionData;
export const getEffectiveContactData  = dashboardService.getEffectiveContactData;
export const getLossReasonsData       = dashboardService.getLossReasonsData;
export const getForecastData          = dashboardService.getForecastData;
export const getTrackingData          = dashboardService.getTrackingData;
export const getEnterpriseDashboardData = dashboardService.getEnterpriseDashboardData;
export const getEnterpriseTeams       = dashboardService.getEnterpriseTeams;
export const getEnterpriseClientSales = dashboardService.getEnterpriseClientSales;

// ─── Tipos ──────────────────────────────────────────────────────
export type {
  DashboardParams,
  ActivitiesStats,
  AcqChannelBar,
  LeadAcquisitionData,
  EffectiveContactRow,
  ForecastRow,
  EnterpriseDashboardData,
  EnterpriseBreakdownRow,
  EnterpriseStageRow,
  EnterpriseTeamRow,
  EnterpriseTeamBreakdownRow,
  EnterpriseSaleRow,
} from '@modules/dashboard';
